import { createApiModule, createQueryString } from 'api/common/utls';
import apiClient from '../client';
import {
  VERSIONS,
  SERVICES,
  RESOURCES,
  BASE_ENDPOINTS
} from 'api/common/constants';

// Define base paths
const FARMER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.FARMER,
  false // No tenant ID in this path
);

export const getFarmerReportdata = ({ cursor, limit, tenant, filter }) => {
  const baseURL = apiClient.defaults.baseURL;

  const url = `${FARMER_BASE}/report`;
  const fullURL = `${baseURL}/${url}`;

  return apiClient.post(url, {
    cursor,
    limit,
    filters: filter
  });
};
// Define API methods
const apiMethods = {
  // Get farmer report data
  getFarmerReport: (cursor, limit, tenant, filter) => {
    return apiClient.post(`${FARMER_BASE}/report/`, {
      cursor,
      limit,
      tenant,
      ...filter
    });
  },

  // Get dynamic farmer form
  getFarmerForm: () => {
    const queryString = createQueryString({ is_edit: false });
    return apiClient.get(`${FARMER_BASE}/form${queryString}`);
  },

  // Get edit farmer form
  getEditFarmerForm: farmerId => {
    const queryString = createQueryString({
      is_edit: true,
      farmer_id: farmerId
    });
    return apiClient.get(`${FARMER_BASE}/form${queryString}`);
  },

  // Create farmer
  createFarmer: data => {
    return apiClient.post(FARMER_BASE, data);
  },

  // Update farmer
  updateFarmer: (farmerId, data) => {
    return apiClient.put(`${FARMER_BASE}/${farmerId}`, data);
  }
};
export const farmerReportApi = {
  getDynamicFarmerForm: tenantId =>
    apiClient.get(`${FARMER_BASE}/form?is_edit=false`),
  // Post form values of farmer creation

  getEditFarmerForm: (tenantId, farmerId) =>
    apiClient.get(`${FARMER_BASE}/form?is_edit=true&farmer_id=${farmerId}`),
  sendFarmerCreate: (tns_tenant, data) =>
    apiClient.post(`${FARMER_BASE}`, data),

  getEditFarmerData: (tenantId, farmerId) =>
    apiClient.get(`${FARMER_BASE}/${farmerId}`),

  getDynamicForm: tenantId => apiClient.post(`${FARMER_BASE}/sms/form`),

  sendFarmerSms: (tns_tenant, data) =>
    apiClient.post(`${FARMER_BASE}/sms`, data),

  sendFarmerEdit: (tns_tenant, farmer_id, data) =>
    apiClient.put(`${FARMER_BASE}/${farmer_id}`, data)
};
export const getSMSData = async ({ tenant, id }) => {
  const data = await apiClient.post(`${FARMER_BASE}/sms/data/${id}`);
  return data;
};
export const resendSMSData = async ({ requestID, id }) => {
  const data = await apiClient.get(
    `${FARMER_BASE}/sms/resend?request_id=${requestID}&status_id=${id}`
  );
  return data;
};
// Create API module with error handling
export const farmerApi = createApiModule(apiMethods);
